export default __webpack_public_path__ + "static/media/osx-el-capitan-finder-icon.fcc22ca0.webp";